export default __webpack_public_path__ + "static/media/side-image.80d2b8ac.png";